import axios from 'axios'

import getHeaders from '../../helpers/headers'
import config from '../../../constants/endpoints.js'
const { translations } = config.endpoints.intranet

const getTranslationsList = data => axios({
  method: 'POST',
  url: translations.list,
  data,
  headers: getHeaders(true)
})

const updateTranslation = data => axios({
  method: 'POST',
  url: translations.update,
  data,
  headers: getHeaders(true)
})

const removeTranslation = data => axios({
  method: 'POST',
  url: translations.remove,
  data,
  headers: getHeaders(true)
})

const getLabelsList = data => axios({
  method: 'POST',
  url: translations.labelsList,
  data,
  headers: getHeaders(true)
})

const createLabel = data => axios({
  method: 'POST',
  url: translations.createLabel,
  data,
  headers: getHeaders(true)
})

const updateLabel = data => axios({
  method: 'POST',
  url: translations.updateLabel,
  data,
  headers: getHeaders(true)
})

export default {
  getTranslationsList,
  updateTranslation,
  removeTranslation,
  getLabelsList,
  createLabel,
  updateLabel
}
